import { Grid, Typography, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText, Alert } from "@mui/material";
import { Container } from "@mui/system";
import globals from "../globals";
import RedButton from "../components/redButton";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const Unsubscribe = () => {
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const session = searchParams.get('session');
    const navigate = useNavigate();

    const handleClickOpen = async () => {
        if (!session) {
            setError('Невалиден линк за отписване. Моля, използвайте линка от имейла си.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${globals.apiUrl}/marketing/unsubscribe`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ session }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.detail || 'Възникна грешка при отписването.');
            }

            setOpen(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Container>
            <Grid container justifyContent={'center'} sx={{ mt: 15 }} textAlign={'center'} direction={'column'}>
                <Grid item>
                    <img src="/eacademiabg-logo.webp" style={{ width: 300, height: 150 }} alt="eAcademiaBg" />
                </Grid>
                <Grid item>
                    <Typography sx={{ fontSize: 35, color: globals.colors.darkBlue, fontWeight: 'bold' }}>
                        Потвърдете отписването си
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ fontSize: 20, color: globals.colors.darkBlue, mt: 3 }}>
                        Вие сте на път да се откажете от нашите имейли.
                        След като потвърдите, няма да получавате повече бюлетини и промоции от нас.
                    </Typography>
                </Grid>

                {error && (
                    <Grid item sx={{ mt: 3 }}>
                        <Alert severity="error">{error}</Alert>
                    </Grid>
                )}

                <Grid item sx={{ mt: 4 }}>
                    <RedButton
                        text={loading ? 'Обработване...' : 'Потвърждавам'}
                        onClick={handleClickOpen}
                        disabled={loading}
                    />
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle sx={{ color: globals.colors.darkRed }}>
                            {"Успешно се отписахте!"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Вашият имейл е премахнат от списъка ни
                                и няма да получавате повече съобщения.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <RedButton onClick={() => { handleClose(); navigate('/'); }} text={'ОK'} />
                        </DialogActions>
                    </Dialog>
                </Grid>
                <Grid item>
                    <Typography sx={{ fontSize: 15, color: globals.colors.gray, mt: 3 }}>
                        Ако не искате да се отписвате, можете просто да затворите тази страница.
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
};

export default Unsubscribe;
